/* GZK Scarcity Test, 12-statement version — soulaura.ai
   Fixed-rule, no-AI test. One statement per screen. Answers: Yes = 2, Sometimes = 1, No = 0.
   The 12 statements are taken from the 20-statement version (gzk-kitlik-testi.js): 4 per corner,
   every Code Group at least once. All group, corner and report texts are verbatim from that version.
   Turkish: statement, group and corner texts come from window.GZK_DATA_TR (gzk-tr.js). */
(function () {
  var CODES = [64, 25, 13, 1, 55, 34, 87, 75, 45, 96, 29, 37];
  var N = CODES.length;
  var MAXC = 8;
  var KEY = "gzk_a12";

  var DATA = {
    items: [
      { code: 64, text: "There won't be enough.", group: 7, corner: "FEAR" },
      { code: 25, text: "What I do isn't worth that much money.", group: 3, corner: "UNWORTH" },
      { code: 13, text: "Money corrupts people.", group: 2, corner: "GUILT" },
      { code: 1, text: "People in my family don't get rich.", group: 1, corner: "FEAR" },
      { code: 55, text: "You can't make money doing what comes easy.", group: 6, corner: "UNWORTH" },
      { code: 34, text: "If I get rich, I'll lose my spiritual path.", group: 4, corner: "GUILT" },
      { code: 87, text: "If I earn more than the people around me, they won't accept me anymore.", group: 9, corner: "FEAR" },
      { code: 75, text: "Asking is shameful. I shouldn't let my needs show.", group: 8, corner: "UNWORTH" },
      { code: 45, text: "Rich people are thieves. Nobody gets rich honestly.", group: 5, corner: "GUILT" },
      { code: 96, text: "You can't trust people. Partnerships fail.", group: 10, corner: "FEAR" },
      { code: 29, text: "If I raise my prices, no one will come.", group: 3, corner: "UNWORTH" },
      { code: 37, text: "If I charge for work I do out of love, it gets tainted.", group: 4, corner: "GUILT" }
    ],
    texts: {
      SABIT_UCGEN: "If money isn't coming to you, the reason is almost never outside. Inside, there's a structure protecting you from money. I call it the Scarcity Triangle. It has three corners, and each corner whispers a lie to you. When all three join, an identity is born in the middle: the you who says, \"Money, stay away from me.\"",
      SABIT_AYNA: "If you were money, would you come to yourself? If not, why not? Write whatever comes up. The first answers are usually the most honest.",
      SABIT_GECIS: "This showed you why money hasn't found you. It didn't show you where it will flow from. The Scarcity Triangle kept you locked inside. The Authentic Wealth Triangle shows you where money will flow to you from: where you're already rich, your talents, and your dream. Where all three meet is your True Wealth Code.",
      KOSE_DEG: "**Unworthiness — \"You're not enough.\"** It stops you from seeing what you're good at. This is the deepest corner of the Scarcity Triangle. Money is a result. Its source is the value you place on yourself. If your marks gather here, you're not worthless. You need to remember your worth.",
      KOSE_SUC: "**Guilt — \"You'll be tainted.\"** It stops you from connecting your talent to money. You see money as dirty. This code stains both earning and asking.",
      KOSE_KOR: "**Fear — \"You'll lose.\"** It stops you from going your own way. This code freezes both investing and getting close.",
      GORUNUS_01: "You can't rise much above your family's income. When you do, you feel uneasy, guilty, and a voice asks, \"Who do you think you are?\"",
      GORUNUS_02: "You feel guilty when you make money. You stay small to stay \"clean.\" You see wealth as someone else's dirty game.",
      GORUNUS_03: "You quote low prices. You can't ask for a raise. You say \"it's fine.\" When money comes in, you think, \"There must be a mistake.\"",
      GORUNUS_04: "You're gifted, deep, a healer, and ashamed to charge. You're stuck on \"you don't take money for work done with love.\" You see abundance as selling out.",
      GORUNUS_05: "Seeing rich people stirs up anger or contempt. Your reflex is \"they must have cheated.\" When a chance to build wealth shows up, you sabotage it without knowing why.",
      GORUNUS_06: "You dismiss easy opportunities. You're ashamed to ask for money for work you enjoy. You keep making things hard for yourself. You feel guilty when you rest.",
      GORUNUS_07: "Constant math, constant worry. The more you earn, the louder \"it should be more\" gets. You tense up when you spend. You keep playing the \"what if I lose it all\" movie. You want a lot, then don't like what comes.",
      GORUNUS_08: "You push compliments away. You downplay gifts. You don't ask for help. You quote your price like you're apologizing. You hide your wins.",
      GORUNUS_09: "You feel guilty when you out-earn the people around you. You give your work away free so \"money doesn't come between us.\" You hide money from your partner or family. You tell your wins smaller than they are.",
      GORUNUS_10: "You fear risk, or the opposite: you gamble without thinking. You fear partnerships. You can't trust anyone with money. You replay an old loss over and over.",
      GRUP_01: { title: "Ancestry and Family · Fear · \"You'll lose.\"", voice: "\"Who do you think you are, rising above your family's fate? Know your place.\"", turn: "Loyalty is shown with love, not with poverty. You honor your ancestors by opening the door they couldn't, not by repeating their scarcity." },
      GRUP_02: { title: "Religion, Culture and Morality · Guilt · \"You'll be tainted.\"", voice: "\"Stay a good person, stay clean. Which means stay away from money. Money ruins people like you.\"", turn: "Abundance is a core value in almost every tradition. Money isn't dirty. Some ways of using it are. A person who takes in abundance and lets it flow toward good is at the very heart of the spiritual life." },
      GRUP_03: { title: "Unworthiness and Deserving · Unworthiness · \"You're not enough.\"", voice: "\"Prove yourself first. You're not at that level yet, and you know it.\"", turn: "You don't earn deserving through performance. It comes with being here. People who know their worth get valued. Your price is your self-worth, read from the outside." },
      GRUP_04: { title: "Spirituality vs. Money · Guilt · \"You'll be tainted.\"", voice: "\"You're above this. Money is a low form of energy. Stay hungry, but stay pure.\"", turn: "Spirit and matter are two ends of a seesaw. Reject one and you lose your balance. Getting paid for your service is the only way that service can last. A starving healer heals no one." },
      GRUP_05: { title: "Judgments About the Rich · Guilt · \"You'll be tainted.\"", voice: "\"Look at them… You don't want to be one of them, do you?\"", turn: "Wealth isn't a character. It's a capacity. When a good person gets rich, their goodness scales. When you get rich, you don't become \"one of them.\" You become yourself, with more room to move." },
      GRUP_06: { title: "Effort and Hardship · Unworthiness · \"You're not enough.\"", voice: "\"Money that comes without sweat brings no good. Choose the hard way so you've earned it.\"", turn: "What comes easy to you is what you were given naturally, and that's exactly why it's your most valuable way to serve. People don't pay for your struggle. They pay for your ease." },
      GRUP_07: { title: "Scarcity and Security · Fear · \"You'll lose.\"", voice: "\"Don't spend. Save. You never know what tomorrow brings, so don't come crying to me.\"", turn: "Scarcity isn't an outside condition. It's a way of focusing. Focus on lack and lack multiplies. Focus on what's there and that multiplies. Security doesn't live in how much you've saved. It lives in knowing you're never alone and always protected." },
      GRUP_08: { title: "Receiving and Visibility · Unworthiness · \"You're not enough.\"", voice: "\"Don't ask. Don't show what you need. Don't be seen. Whatever's seen becomes a target.\"", turn: "Giving and receiving are like breathing. Refuse one and the flow stops. Being visible isn't ego. It's service. People who can't find you can't buy from you." },
      GRUP_09: { title: "Relationships and Belonging · Fear · \"You'll lose.\"", voice: "\"Grow and you'll end up alone. Stay small so you stay one of us.\"", turn: "Love that needs you small isn't love. It's comfort. Real bonds grow as you grow. Your abundance is the most concrete kindness you can bring to the people you love." },
      GRUP_10: { title: "Control, Loss and Old Wounds · Fear · \"You'll lose.\"", voice: "\"Did you forget that day? Want to live it again? Stay right where you are.\"", turn: "It happened once. You're the one reliving it every day. An old loss carried as a lesson is capital. Carried as an identity, it's a prison." },
      HARITA_TEK_DEG: "Your marks gather in one corner: Unworthiness, \"You're not enough.\" Your money story has one corner. All the work is in one place, so change comes fast. You only have to dig in one spot.",
      HARITA_TEK_SUC: "Your marks gather in one corner: Guilt, \"You'll be tainted.\" Your money story has one corner. All the work is in one place, so change comes fast. You only have to dig in one spot.",
      HARITA_TEK_KOR: "Your marks gather in one corner: Fear, \"You'll lose.\" Your money story has one corner. All the work is in one place, so change comes fast. You only have to dig in one spot.",
      HARITA_KES_DEG_SUC: "Your two strongest Code Groups point to different corners: Unworthiness and Guilt. You have an intersection: one corner shuts the door, the other hides the key. So order matters. Start with Unworthiness and its voice, \"You're not enough.\" Guilt usually loosens after it.",
      HARITA_KES_DEG_KOR: "Your two strongest Code Groups point to different corners: Unworthiness and Fear. You have an intersection: one corner shuts the door, the other hides the key. So order matters. Start with Unworthiness and its voice, \"You're not enough.\" Fear usually loosens after it.",
      HARITA_KES_SUC_DEG: "Your two strongest Code Groups point to different corners: Guilt and Unworthiness. You have an intersection: one corner shuts the door, the other hides the key. So order matters. Start with Guilt and its voice, \"You'll be tainted.\" Unworthiness usually loosens after it.",
      HARITA_KES_SUC_KOR: "Your two strongest Code Groups point to different corners: Guilt and Fear. You have an intersection: one corner shuts the door, the other hides the key. So order matters. Start with Guilt and its voice, \"You'll be tainted.\" Fear usually loosens after it.",
      HARITA_KES_KOR_DEG: "Your two strongest Code Groups point to different corners: Fear and Unworthiness. You have an intersection: one corner shuts the door, the other hides the key. So order matters. Start with Fear and its voice, \"You'll lose.\" Unworthiness usually loosens after it.",
      HARITA_KES_KOR_SUC: "Your two strongest Code Groups point to different corners: Fear and Guilt. You have an intersection: one corner shuts the door, the other hides the key. So order matters. Start with Fear and its voice, \"You'll lose.\" Guilt usually loosens after it.",
      KOK_001: { remaining: 10, range: "Codes 1–11" },
      KOK_013: { remaining: 10, range: "Codes 12–22" },
      KOK_025: { remaining: 10, range: "Codes 23–33" },
      KOK_029: { remaining: 10, range: "Codes 23–33" },
      KOK_034: { remaining: 9, range: "Codes 34–43" },
      KOK_037: { remaining: 9, range: "Codes 34–43" },
      KOK_045: { remaining: 9, range: "Codes 44–53" },
      KOK_055: { remaining: 9, range: "Codes 54–63" },
      KOK_064: { remaining: 10, range: "Codes 64–74" },
      KOK_075: { remaining: 9, range: "Codes 75–84" },
      KOK_087: { remaining: 9, range: "Codes 85–94" },
      KOK_096: { remaining: 9, range: "Codes 95–104" }
    },
    corners: {
      UNWORTH: { label: "Unworthiness", whisper: "You're not enough.", key: "KOSE_DEG" },
      GUILT: { label: "Guilt", whisper: "You'll be tainted.", key: "KOSE_SUC" },
      FEAR: { label: "Fear", whisper: "You'll lose.", key: "KOSE_KOR" }
    },
    ui: {
      resultEyebrow: "Your result",
      groups: "Your strongest Code Groups",
      voice: "The Scarcity Voice",
      turn: "Where to turn",
      cta: "Find your True Wealth Code",
      triangle: "Your Scarcity Triangle",
      shows: "How it shows up in your life:",
      footer: "The corner you gather in is not your character. It's just the address of the door life brought you to.",
      root: "**Your root code candidate: {code_no}. {code}**\nAsk this code one question: \"What would happen if this weren't true?\" If your mind fires back an answer and jumps to another sentence, that's a branch. Follow the sentence it jumped to. If no answer comes and something happens in your body, that's the root. The mind argues with branches. The body reacts to roots.\nThe other {remaining} codes in this Code Group are in Appendix A ({range})."
    }
  };

  /* Strings that differ from the 20-statement version (count, intro, answer buttons). */
  var NEW = {
    en: {
      texts: {
        SABIT_YONERGE: "Twelve statements, one at a time. If your body reacts as you read (a tight chest, a lump in your throat, a quick urge to defend), tap Yes. If only your mind says \"makes sense,\" tap No. In between: Sometimes.",
        SABIT_SAYI: "{n} of the 12 statements touched you.",
        SABIT_KITAP: "This test showed you 12 of the 108 codes. The other 96 are in Appendix A, in the workbook at the back of the book. The technique for releasing your root code is in Chapter 7: release first, then install the positive counter-code. You can't change what you can't name.",
        UC_A: "None of these 12 statements got a reaction from your body. That means one of two things. One: these money codes really are light in you. Nobody carries all 108, and for some people the block isn't about money. Two: you read the statements with your head. The only rule was this: if your body reacted while reading, tap Yes. If only your mind said \"makes sense,\" tap No."
      },
      ui: {
        eyebrow: "Free test · about 3 minutes",
        heading: "Why isn't money coming to you?",
        yes: "Yes",
        sometimes: "Sometimes",
        no: "No",
        prev: "Back",
        step: "{n} of {total}",
        retake: "Retake the test"
      }
    },
    tr: {
      texts: {
        SABIT_YONERGE: "On iki cümle, tek tek. Okurken bedenin tepki veriyorsa (göğüste sıkışma, boğazda düğüm, içten gelen savunma refleksi) Evet de. Sadece zihnin \"mantıklı\" diyorsa Hayır de. Arada kalıyorsan Bazen.",
        SABIT_SAYI: "12 cümlenin {n} tanesi sana dokundu.",
        SABIT_KITAP: "Bu test 108 kodun 12’sini gösterdi. Kalan 96 kod, kitabın sonundaki Çalışma Defteri’nde, Ek A’da. Kök kodunu bıraktığın teknik Bölüm 7’de: önce bırak, sonra olumlu karşı-kodu yükle. Adını koyamadığın şeyi dönüştüremezsin.",
        UC_A: "Bu 12 cümlenin hiçbiri bedeninde tepki vermedi. İki ihtimal var. Birincisi: parayla ilgili bu kodlar sende gerçekten az; kimse yüz sekiz kodun hepsini taşımaz ve bazı insanların engeli paradan geçmez. İkincisi: cümleleri zihninle okudun. Tek kural şuydu: okurken beden tepki verdiyse Evet de, sadece zihin \"mantıklı\" dediyse Hayır de."
      },
      ui: {
        eyebrow: "Ücretsiz test · yaklaşık 3 dakika",
        heading: "Para sana neden gelmiyor?",
        yes: "Evet",
        sometimes: "Bazen",
        no: "Hayır",
        prev: "Geri",
        step: "{n} / {total}",
        retake: "Testi yeniden çöz"
      }
    }
  };

  var KEYMAP = { UNWORTH: "DEG", GUILT: "SUC", FEAR: "KOR" };
  var PRIO = { UNWORTH: 0, GUILT: 1, FEAR: 2 };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function md(s) {
    return esc(s).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\n/g, "<br>");
  }
  function pad(n, w) {
    var s = String(n);
    while (s.length < w) s = "0" + s;
    return s;
  }
  function merge(a, b) {
    var o = {}, k;
    for (k in a) o[k] = a[k];
    for (k in b) o[k] = b[k];
    return o;
  }

  function init(root) {
    var useTr = root.getAttribute("data-lang") === "tr" && !!window.GZK_DATA_TR;
    var D = useTr ? window.GZK_DATA_TR : DATA;
    var ov = useTr ? NEW.tr : NEW.en;
    var T = merge(D.texts, ov.texts);
    var U = merge(D.ui, ov.ui);
    var C = {};
    ["UNWORTH", "GUILT", "FEAR"].forEach(function (k) {
      C[k] = merge(D.corners[k], { max: MAXC });
    });
    var items = CODES.map(function (c) {
      return D.items.filter(function (i) { return i.code === c; })[0];
    });
    var paidUrl = root.getAttribute("data-paid-url") || "";
    var answers = [];
    var cur = 0;
    var locked = false;

    var testEl = root.querySelector(".gzk-test");
    var resEl = root.querySelector(".gzk-result");
    var listEl = root.querySelector(".gzk-list");
    var reportEl = root.querySelector(".gzk-report");

    root.querySelector(".gzk-eyebrow").textContent = U.eyebrow;
    root.querySelector(".gzk-heading").textContent = U.heading;
    root.querySelector(".gzk-intro").textContent = T.SABIT_YONERGE;
    root.querySelector(".gzk-result-eyebrow").textContent = U.resultEyebrow;
    root.querySelector(".gzk-back").textContent = U.retake;

    /* Step UI: replaces the plain statement list (kept in the HTML for search engines and no-JS). */
    listEl.innerHTML =
      '<div class="gzk-progress" role="progressbar" aria-valuemin="0" aria-valuemax="' + N + '" aria-valuenow="1"><span></span></div>' +
      '<div class="gzk-stepmeta"><span class="gzk-stepno"></span><button type="button" class="gzk-prev"></button></div>' +
      '<p class="gzk-q" id="gzk-q" aria-live="polite"></p>' +
      '<div class="gzk-answers" role="group" aria-labelledby="gzk-q">' +
      '<button type="button" class="gzk-ans" data-v="2"></button>' +
      '<button type="button" class="gzk-ans" data-v="1"></button>' +
      '<button type="button" class="gzk-ans" data-v="0"></button>' +
      "</div>";
    var barEl = listEl.querySelector(".gzk-progress");
    var fillEl = barEl.querySelector("span");
    var noEl = listEl.querySelector(".gzk-stepno");
    var prevEl = listEl.querySelector(".gzk-prev");
    var qEl = listEl.querySelector(".gzk-q");
    var ansEls = listEl.querySelectorAll(".gzk-ans");
    var labels = { 2: U.yes, 1: U.sometimes, 0: U.no };
    prevEl.textContent = U.prev;
    for (var a = 0; a < ansEls.length; a++) ansEls[a].textContent = labels[ansEls[a].getAttribute("data-v")];

    function paint() {
      qEl.textContent = items[cur].text;
      noEl.textContent = U.step.replace("{n}", cur + 1).replace("{total}", N);
      fillEl.style.width = (cur / N * 100) + "%";
      barEl.setAttribute("aria-valuenow", cur + 1);
      prevEl.style.visibility = cur === 0 ? "hidden" : "visible";
      for (var i = 0; i < ansEls.length; i++) {
        var v = Number(ansEls[i].getAttribute("data-v"));
        ansEls[i].setAttribute("aria-pressed", answers[cur] === v ? "true" : "false");
      }
    }

    function answer(v) {
      if (locked) return;
      answers[cur] = v;
      paint();
      locked = true;
      setTimeout(function () {
        locked = false;
        if (cur < N - 1) { cur++; paint(); } else { finish(true); }
      }, 220);
    }

    function score() {
      var cc = { UNWORTH: 0, GUILT: 0, FEAR: 0 };
      var gs = {}, gmax = {}, gc = {}, touched = 0, g;
      for (g = 1; g <= 10; g++) { gs[g] = 0; gmax[g] = 0; }
      items.forEach(function (it, i) {
        var w = answers[i] || 0;
        gc[it.group] = it.corner;
        gmax[it.group] += 2;
        gs[it.group] += w;
        cc[it.corner] += w;
        if (w > 0) touched++;
      });
      /* Strongest group = highest share of its own possible points (groups 3 and 4 have two statements,
         the others one). Ties: raw points, corner total, deeper corner first, group number. */
      var order = Object.keys(gs).map(Number).sort(function (a, b) {
        return (gs[b] / gmax[b] - gs[a] / gmax[a]) || (gs[b] - gs[a]) ||
               (cc[gc[b]] - cc[gc[a]]) || (PRIO[gc[a]] - PRIO[gc[b]]) || (a - b);
      });
      var top = order[0], second = order[1];
      var showSecond = gs[second] > 0;
      var start = gc[top];
      var single = !showSecond || gc[second] === start;
      var rootItem = items.map(function (it, i) { return { it: it, w: answers[i] || 0 }; })
        .filter(function (x) { return x.it.group === top && x.w > 0; })
        .sort(function (a, b) { return (b.w - a.w) || (a.it.code - b.it.code); })[0];
      return { n: touched, cc: cc, gc: gc, top: top, second: second, showSecond: showSecond,
               start: start, single: single, rootItem: rootItem ? rootItem.it : null };
    }

    function renderReport() {
      var r = score(), h = "";
      h += '<div class="gzk-sec"><p class="gzk-big">' + esc(T.SABIT_SAYI.replace("{n}", r.n)) + "</p></div>";
      if (r.n === 0) {
        h += '<div class="gzk-sec"><p>' + esc(T.UC_A) + "</p></div>";
      } else {
        h += '<div class="gzk-sec"><h3 class="gzk-h3">' + esc(U.triangle) + "</h3><p>" + esc(T.SABIT_UCGEN) + '</p><div class="gzk-meter">';
        ["UNWORTH", "GUILT", "FEAR"].forEach(function (k) {
          var v = r.cc[k], m = C[k].max;
          h += '<div class="gzk-mrow"><div class="gzk-mlabel">' + esc(C[k].label) +
               ' <span>&laquo;' + esc(C[k].whisper) + '&raquo;</span></div><div class="gzk-mval">' + v + "/" + m +
               '</div><div class="gzk-track"><div class="gzk-fill gzk-c-' + k.toLowerCase() +
               '" style="width:' + (v / m * 100) + '%"></div></div></div>';
        });
        h += "</div></div>";

        var g1 = T["GRUP_" + pad(r.top, 2)];
        h += '<div class="gzk-sec"><div class="gzk-label">' + esc(U.groups) + '</div><div class="gzk-chips">';
        h += '<span class="gzk-chip gzk-c-' + r.gc[r.top].toLowerCase() + '">' + esc(g1.title) + "</span>";
        if (r.showSecond) {
          h += '<span class="gzk-chip gzk-c-' + r.gc[r.second].toLowerCase() + '">' +
               esc(T["GRUP_" + pad(r.second, 2)].title) + "</span>";
        }
        h += "</div>";
        var mapKey = r.single
          ? "HARITA_TEK_" + KEYMAP[r.start]
          : "HARITA_KES_" + KEYMAP[r.start] + "_" + KEYMAP[r.gc[r.second]];
        h += "<p>" + esc(T[mapKey]) + "</p>";
        h += '<div class="gzk-corner gzk-c-' + r.start.toLowerCase() + '"><p>' + md(T[C[r.start].key]) +
             '</p><p class="gzk-foot">' + esc(U.footer) + "</p></div></div>";

        var k = T["KOK_" + pad(r.rootItem.code, 3)];
        var rootTxt = U.root.replace("{code_no}", r.rootItem.code)
          .replace("{code}", "“" + r.rootItem.text + "”")
          .replace("{remaining}", k.remaining).replace("{range}", k.range);
        h += '<div class="gzk-sec"><div class="gzk-rootcode">' + md(rootTxt) + "</div>";
        h += '<div class="gzk-label">' + esc(U.shows) + "</div><p>" + esc(T["GORUNUS_" + pad(r.top, 2)]) + "</p>";
        h += '<div class="gzk-label">' + esc(U.voice) + '</div><p class="gzk-voice">' + esc(g1.voice) + "</p>";
        h += '<div class="gzk-label">' + esc(U.turn) + "</div><p>" + esc(g1.turn) + "</p></div>";
      }
      h += '<div class="gzk-sec"><p>' + esc(T.SABIT_KITAP) + '</p><div class="gzk-mirror"><p class="gzk-voice">' +
           esc(T.SABIT_AYNA) + "</p></div></div>";
      h += '<div class="gzk-sec"><p>' + esc(T.SABIT_GECIS) + "</p>";
      if (paidUrl) h += '<a class="gzk-btn gzk-cta" href="' + esc(paidUrl) + '">' + esc(U.cta) + "</a>";
      h += "</div>";
      reportEl.innerHTML = h;
      try { sessionStorage.setItem("gzk_start_corner", r.n ? r.start : ""); } catch (e) {}
    }

    function finish(scroll) {
      renderReport();
      try { sessionStorage.setItem(KEY, JSON.stringify(answers)); } catch (e) {}
      testEl.hidden = true;
      resEl.hidden = false;
      if (scroll) resEl.scrollIntoView({ block: "start" });
    }

    for (var b = 0; b < ansEls.length; b++) {
      ansEls[b].addEventListener("click", function () { answer(Number(this.getAttribute("data-v"))); });
    }
    prevEl.addEventListener("click", function () {
      if (locked || cur === 0) return;
      cur--;
      paint();
    });
    root.querySelector(".gzk-back").addEventListener("click", function () {
      answers = [];
      cur = 0;
      paint();
      resEl.hidden = true;
      testEl.hidden = false;
      testEl.scrollIntoView({ block: "start" });
    });

    /* Email box: adds the reading language as a tag (ui-xx). The store language alone is not enough:
       most languages are served by the auto-translate app, which sets <html lang> after it translates. */
    var form = root.querySelector("#gzk-nl-form");
    if (form) {
      form.addEventListener("submit", function () {
        var t = form.querySelector('input[name="contact[tags]"]');
        var l = (document.documentElement.lang || navigator.language || "").toLowerCase().slice(0, 2);
        if (t && l && t.value.indexOf("ui-") < 0) t.value += ", ui-" + l;
      });
    }

    paint();

    /* After the email form is sent the page reloads: put the result back on screen.
       Answers stay in this browser tab (sessionStorage) and are never sent anywhere. */
    if (root.querySelector("[data-gzk-posted]")) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (e) {}
      if (saved && saved.length === N) {
        answers = saved;
        finish(false);
        var nl = root.querySelector("#gzk-nl");
        if (nl) nl.scrollIntoView({ block: "center" });
      }
    }
  }

  function boot() {
    var nodes = document.querySelectorAll(".gzk-root:not([data-gzk-ready])");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute("data-gzk-ready", "1");
      init(nodes[i]);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
